import { clsx } from 'clsx'
import CfSectionShell, { CfSectionShellFields } from '../cf-section-shell'
import { CallToAction } from '~/utils/a-b'
import { Stack, TypewriterInput } from '~/components-v2'
import type { CfImage } from '~/types/contentful'
import { getTypewriterScenario } from '~/components-v2/typewriter-input/scenarios'
import { CfMedia } from '../cf-media'

export interface HeroFields {
  headline: string
  copy?: string
  image?: CfImage
  mobileImage?: CfImage
  mediaVariant?: 'image' | 'typewriter'
  typewriterScenario?: string
}

interface CfHeroSectionProps {
  fields: CfSectionShellFields & HeroFields
}

export function CfHeroSection({ fields }: CfHeroSectionProps) {
  const { id, paddingTop, paddingBottom, showBottomBorder, theme } = fields
  const {
    headline,
    copy,
    image,
    mobileImage,
    mediaVariant,
    typewriterScenario,
  } = fields
  const imageUrl = image?.fields?.file?.url
  const mobileImageUrl = mobileImage?.fields?.file?.url

  const showTypewriter = mediaVariant === 'typewriter'
  const scenario = getTypewriterScenario(typewriterScenario)

  return (
    <CfSectionShell
      id={id}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      showBottomBorder={showBottomBorder}
      theme={theme}
      mobileNoTopPadding
    >
      <header
        className={clsx('cf-hero', showTypewriter && 'cf-hero--typewriter')}
      >
        <Stack as="hgroup" gap={8}>
          {headline && <h1 className="heading-xl">{headline}</h1>}

          {copy && <h2>{copy}</h2>}

          <CallToAction />
        </Stack>

        <div
          className={clsx(
            'product-imagery',
            showTypewriter && 'cf-hero-typewriter',
          )}
        >
          {showTypewriter ? (
            <TypewriterInput scenario={scenario} />
          ) : imageUrl ? (
            <figure className="cf-hero-image">
              <CfMedia
                className={clsx(mobileImage ? 'desktop-img' : '')}
                media={image}
              />

              {mobileImageUrl && (
                <CfMedia className="mobile-img" media={mobileImage} />
              )}
            </figure>
          ) : null}
        </div>
      </header>
    </CfSectionShell>
  )
}
